import { useOnlineStatus } from "../../hooks/useOnlineStatus";
import { tr } from "../../i18n";

/**
 * Banner globale: si mostra in alto quando il browser è offline.
 * Da montare nell'App.tsx subito sotto BrowserRouter.
 */
export function OfflineBanner() {
  const online = useOnlineStatus();
  if (online) return null;
  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-warning text-ink text-center text-sm font-bold py-2 shadow-lg">
      {tr(
        tr(
          "⚠ Offline — dati cached visibili in read-only · azioni di mercato/formazione non disponibili",
        ),
      )}
    </div>
  );
}
